module.exports = __webpack_public_path__ + "files/d145ec3ae2e1517f05430fccaacc6a20.png";


//////////////////
// WEBPACK FOOTER
// ./images/appIcons.png
// module id = 1940
// module chunks = 60